export const GET_TASK_RFCE = 'GET_TASK_RFCE'
export const ADD_TASK_RFCE = 'ADD_TASK_RFCE'
export const DONE_TASK_RFCE = 'DONE_TASK_RFCE'
export const REJECT_TASK_RFCE = 'REJECT_TASK_RFCE'
export const DELETE_TASK_RFCE = 'DELETE_TASK_RFCE'